import React from "react";
import { Modal, Spinner } from "react-bootstrap";

const DrStepper = ({ data, showModal, onClose }) => {
console.log(data, "rtoData")
  return (
    <Modal show={showModal} onHide={onClose} centered>  
      <Modal.Header closeButton>
        <Modal.Title>RTO Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!data ? (
          // If data is null
          <div className="text-center py-4">
            <Spinner animation="border" role="status" className="mb-2" />
            <div className="text-muted">Pls wait for few minutes...</div>
          </div>
        ) : (
          <>
        <div className="d-flex justify-content-between align-items-center mb-4">

          {/* Step 1 */}
          <div className="text-center flex-fill">
            <div className="mb-2">
              <span className="badge bg-success rounded-circle p-3">
                <i className="fas fa-plus"></i>
              </span>
            </div>
            <h6 className="mb-1">Resource Creation</h6>
            <small className="text-muted">
              {data?.operation1LocalTime}
            </small>
            <small className="d-block text-truncate" title={data?.operationName1}>
                  {data?.targetName}
             </small>
          </div>

          {/* Line between steps */}
          <div className="flex-fill border-top border-2 mx-2"></div>

          {/* Step 2 */}
          <div className="text-center flex-fill">
            <div className="mb-2">
              <span className="badge bg-danger rounded-circle p-3">
                <i className="fas fa-stop"></i>
              </span>
            </div>
            <h6 className="mb-1">Resource Stopped</h6>
            <small className="text-muted">
              {data?.operation2LocalTime}
            </small>
            <small className="d-block text-truncate" title={data?.operationName1}>
                  {data?.sourceName}
             </small>
          </div>

        </div>

        {/* Duration */}
        <div className="mt-3 p-2 bg-light border rounded text-center">
          <strong>Total Duration:</strong> {data?.Duration}
        </div></>)}
      </Modal.Body> 
    </Modal>
  );
};

export default DrStepper;
